import { createSlice } from '@reduxjs/toolkit'
import { v4 } from 'uuid'

const initialState = {
  productSelection: {},
  viewType: 'selection',
  cartId: v4()
}

export const orderPlacementSlice = createSlice({
  name: 'basicOrder',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    productUpdate: (state, action) => {
      const { productId, quantity, promo } = action.payload
      state.productSelection = {
        ...state.productSelection,
        [productId]: { quantity, promo }
      }
    },
    productBulkUpdate: (state, action) => {
      state.productSelection = {
        ...state.productSelection,
        ...action.payload
      }
    },
    productRemove: (state, action) => {
      const productId = action.payload
      const newSelection = { ...state.productSelection }
      delete newSelection[productId]
      state.productSelection = newSelection
    },
    selectionClear: (state) => {
      state.productSelection = {}
      state.viewType = 'selection'
      state.cartId = v4()
    },
    viewTypeSet: (state, action) => {
      state.viewType = action.payload
    }
  }
})

export const {
  productUpdate,
  productBulkUpdate,
  productRemove,
  selectionClear,
  viewTypeSet
} = orderPlacementSlice.actions

export const selectProductSelection = (state) => state.orderPlacement.productSelection

export const selectViewType = (state) => state.orderPlacement.viewType

export const selectCartId = (state) => state.orderPlacement.cartId

export default orderPlacementSlice.reducer
